import Swiper, {Navigation, Autoplay} from 'swiper';

const testimonialSlider = document.querySelector(".testimonials__swiper");
if (testimonialSlider) {
	const testimonialSliderSwiper = new Swiper(".testimonials__swiper", {
		modules: [Navigation, Autoplay],
		slidesPerView: 1.15,
		navigation: {
			nextEl: ".testimonials__next",
			prevEl: ".testimonials__prev",
		},
		spaceBetween: 15,
		centeredSlides: true,
		loop: true,
		autoplay: {
			delay: 9000,
		},
		breakpoints: {
			// when window width is >= 640px
			960: {
				slidesPerView: 1.75,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
		},
	});
}